import axios from "axios";
import { getApiBaseUrl } from "../config/environment";

/**
 * Configuração do Axios com detecção automática de ambiente
 * 
 * Ambientes suportados:
 * - localhost: http://localhost:8000/api
 * - demandasv3: https://demandasv3-hmg.fieac.org.br:8000/api
 * - hermes: https://apihermes.fieac.org.br/api
 */

// Configuração base da API
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 300000, // 5 minutos de timeout

  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: false, // Importante: desabilitar cookies/sessões para usar apenas Bearer tokens
});

// Interceptor para requisições - adicionar token automaticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para respostas - tratar erros de autenticação
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Se receber 401 (Unauthorized), limpar autenticação e redirecionar
    if (error.response?.status === 401) {
      console.warn('Token expirado ou inválido. Redirecionando para login...');
      
      // Limpar dados de autenticação
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("auth-storage"); // Limpar Zustand storage
      
      // Redirecionar para login apenas se não estiver já na página de login
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    
    // Se receber 419 (CSRF Token Mismatch), logar o erro para debug
    if (error.response?.status === 419) {
      console.error('CSRF Token Mismatch - Verifique se withCredentials está false e se está usando Bearer token');
      console.error('Request config:', error.config);
    }
    
    return Promise.reject(error);
  }
);

export { api };
export default api;
